// Shown when an event-day device's access ends (card 540f21a4): the event is
// over, or the organizer revoked it. Only the device's own key was removed.
import React from 'react';
import '../Teacher/Oireachtas/oireachtas.css';
import '../Organizer/Oireachtas/organizerOireachtas.css';
import './deviceHome.css';
import { Msr, useMaterialSymbols } from '../Teacher/Oireachtas/components';

export default function DeviceEnded() {
  useMaterialSymbols();
  return (
    <div className="oir dh-page">
      <div className="dh-ended" role="alert">
        <Msr>link_off</Msr>
        <h1>This device's access has ended</h1>
        <p>The event is over, or the organizer stopped this device. To use it again, pair it again.</p>
        <a className="op-btn" href="/device">
          Pair this device
        </a>
      </div>
    </div>
  );
}
